import './footer.css';

const Footer = () => (
  <div>
    <p className="footer"> Created by @Brenda Wihogora</p>
  </div>
);

export default Footer;
